import QuickSearch_SearchResults from "../components/search-results/search-results";
import {QuickSearchResults} from "./search-results";
import KeyboardIterator from "../../../../core/gd/keyboard-iterator/keyboard-iterator";
import asyncSessionLoader from "../../../../core/gd/data/async-session-loader";
import ApiSearch from "../../../../core/gd/api/search";
import {DocumentSystemType} from "../../../../core/model2/doc/types"


const debug = false
// const debug = "QuickSearch"

export default class QuickSearch {

    public query        : string    = '';
    public isSearching  : boolean   = false

    public results      : QuickSearchResults = new QuickSearchResults()

    public keyboardIterator     : KeyboardIterator

    public componentResults!     : any | QuickSearch_SearchResults
    public componentInput!       : any

    public delayedSearch       : any  // debounced func

    constructor() {

        this.keyboardIterator = new KeyboardIterator(this.reRender, [])
        this.delayedSearch = _.debounce(this.loadData, 500)

    }

    get searchEnabled():boolean {
        return !!this.query
    }

    setQuery(query:string):void {

        debug && console.log(debug, "setQuery()", query)


        this.query = query

        this.search()
    }


    reRender = () => {

        debug && console.log(debug, "reRender()")

        // console.log(this.componentResults)
        this.componentResults.reRender()
    }

    cancel = () => {

        debug && console.log(debug, "Cancel()")

        this.query = ''
        this.reRender()
    }

    search() {

        debug && console.log(debug, "search() query=", this.query)

        const query = this.query ? this.query.trim().toLowerCase() : ''

        this.results.clearData()
        this.delayedSearch.cancel()

        if (!query) {
            this.reRender()
            return
        }

        // Search projects
        if (gd.user.settings.quickSearch.projects) {
            this.results.searchProjects(this.query)
        }

        // Search users
        if (gd.user.settings.quickSearch.users && gd.user.acl.canSeeCompanyUsers) {
            this.results.searchUsers(this.query)
        }

        // Modules
        if (gd.user.settings.quickSearch.modules && !gd.user.isClient) {
            this.results.searchModules(this.query)
        }





        if (this.needDBQuery) {
            this.isSearching = true
        } else {
            this.isSearching = false
        }

        this.results.combineResults()

        this.keyboardIterator.setItems(this.results.items)

        this.reRender()


        if (this.needDBQuery) {
            this.delayedSearch()
        }


    }

    get needDBQuery():boolean {
        return gd.user.settings.quickSearch.tasksByShortId || gd.user.settings.quickSearch.tasksByTitle || gd.user.settings.quickSearch.documents
    }





    onSettingsChanged = () => {
        this.search()
    }



    loadData = async () => {

        if (!this.searchEnabled) return false

        try {
            const response = await ApiSearch.quickV2(this.query)

            // So so solution imho - need types... but it's strange ... they alwyas in session should be ?
            if (gd.user.settings.quickSearch.documents) {
                await gd.session.noteTypes
            }


            if (gd.user.settings.quickSearch.tasksByTitle || gd.user.settings.quickSearch.tasksByShortId) {
                this.results.tasks = _.get(response, 'result.tasks', [])

                // if (!gd.user.settings.quickSearch.tasksClosed) {
                //     this.results.tasks = _.filter(this.results.tasks, task => !gd.const.systemStatus.isClosed(task.systemStatus))
                // }

                this.results.tasks = _.orderBy(this.results.tasks, (t)=>{
                    return t.title.toLowerCase()
                })
            }

            if (gd.user.settings.quickSearch.documents) {
                this.results.documents = _.get(response, 'result.notes', [])
                this.results.documents = _.filter(this.results.documents, d=>d.systemType === DocumentSystemType.DEFAULT)
                this.results.documents = _.orderBy(this.results.documents, d=>d.name.toLowerCase())
            }

            await asyncSessionLoader(this.findMissingData())


        } catch (e: any) {
            console.error(e)
            this.results.tasks = []
            this.results.documents = []
            // this._updateOptions()
            // this.setState({ isSearching: false })


        } finally {

            this.isSearching = false
            this.results.combineResults()
            this.keyboardIterator.setItems(this.results.items)
            this.reRender()

        }
    }

    findMissingData() {
        const allProjectsIds: any = []
        const allTaskTypeIds: any = []
        _.map(this.results.tasks, task=>{
            allProjectsIds.push(task.projectId)
            allTaskTypeIds.push(task.taskTypeId)
        })

        const allNoteTypesIds: any = [];
        _.map(this.results.documents, note=>{
            allProjectsIds.push(note.projectId)
            allNoteTypesIds.push(note.noteTypeId)
        })

        return gd.session.findMissing({
            projects: _.uniq(allProjectsIds),
            taskTypes: _.uniq(allTaskTypeIds),
            noteTypes: _.uniq(allNoteTypesIds)
        })
    }


}